import { useState, useEffect, useRef } from 'react';

/**
 * Hook personalizado para debounce que armazena um valor e só o atualiza após um delay
 * @template T - Tipo do valor que será debounced
 * @param {T} value - O valor que será debounced
 * @param {number} [delay=500] - O tempo de delay em milissegundos
 * @returns {T} O valor debounced
 */
export function useDebounce<T>(value: T, delay= 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  const timerRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    // Limpa o timeout anterior se o valor mudar antes do delay
    timerRef.current = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [value, delay]);

  return debouncedValue;
}
